import { v4, v5, validate } from "uuid";

import { uuidV5Namespace } from "../constants/uuid";

export function uuidv5(name: string | ArrayLike<number>) {
  return v5(name, uuidV5Namespace);
}

export function sanitizeUuid(uuid: string | undefined) {
  if (!uuid) return "";
  return uuid.toLowerCase();
}

export function sanitizeOrGenerateUuid(uuid: string | undefined) {
  return uuid === "" || !uuid ? v4() : sanitizeUuid(uuid);
}

/** Like sanitizeOrGenerateUuid, but keeps a non-UUID legacy id (most LEPC and fire department ids) as-is. */
export function sanitizeLegacyIdOrGenerateUuid(id: string | undefined): string {
  const isLegacyId = id && !validate(id);
  return isLegacyId ? id : sanitizeOrGenerateUuid(id);
}
